import { ReactNode } from 'react';
import { IBufferStats, IGeneralStats, IMediaStats } from 'src/interfaces/Stats';
import List from '../../List';
import StatsInfo from '../StatsInfo';

import styles from './styles.module.scss';
export interface IStatsItemProps {
  statsContent: string[];
  title: string;
  statsValue: IMediaStats | IGeneralStats | IBufferStats;
  children?: ReactNode;
}

const StatsItem = ({ statsContent, title, statsValue, children }: IStatsItemProps) => {
  return (
    <List classes={{ listContainer: styles.listContainer, listTitle: styles.listTitle }} title={title} vertical>
      <>
        {statsContent.map((item) => (
          <StatsInfo label={item} key={item} value={statsValue[item]} />
        ))}
        {children}
      </>
    </List>
  );
};

export default StatsItem;
